import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordComplexityValidator(): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
        const val = ctrl.value || '';
        const errs = {} as any;

        // Must be at least 7 characters.
        if (val.length < 7) {
            errs['minLength'] = 7;
            errs['actualLength'] = val.length;
        }

        // Must have at least 1 uppercase letter
        const hasUppercase = /[A-Z]+/.test(val);
        if (!hasUppercase) {
            errs['missingUppercase'] = true;
        }

        // Must have at least 1 lowercase letter
        const hasLowercase = /[a-z]+/.test(val);
        if (!hasLowercase) {
            errs['missingLowercase'] = true;
        }

        // Must have at least 1 number
        const hasNumber = /[0-9]+/.test(val);
        if (!hasNumber) {
            errs['missingNumber'] = true;
        }

        if (Object.keys(errs).length) {
            return {
                complexity: errs,
            };
        } else return null;
    };
}
